import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const base =
  "inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition-[transform,background-color,box-shadow] duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:pointer-events-none hover:-translate-y-0.5 hover:shadow-md";

export function ArcButton({ variant = "ghoulax", to, href, className, children, ...props }) {
  const styles = {
    ghoulax: "hover:brightness-95",
    zyfley: "text-white hover:brightness-95",
    outline: "border",
    ghost: "hover:bg-black/5 dark:hover:bg-white/10",
  };
  const style =
    variant === "ghoulax" ? { backgroundColor: "var(--ghoulax)", color: "var(--ghoulax-fg)" } :
    variant === "zyfley" ? { backgroundColor: "var(--zyfley)" } :
    variant === "outline" ? { backgroundColor: "var(--arc-card)" } : {};

  const cls = cn(base, styles[variant], className);
  if (to) return <Link to={to} className={cls} style={style} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} style={style} {...props}>{children}</a>;
  return <button className={cls} style={style} {...props}>{children}</button>;
}
